var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { InputContainer, InputField, InputWrapper, Label } from './styles';
var Input = function (_a) {
    var children = _a.children, error = _a.error, warning = _a.warning, touched = _a.touched, floatingLabel = _a.floatingLabel, value = _a.value, fontSize = _a.fontSize, fontFamily = _a.fontFamily, fontWeight = _a.fontWeight, lineHeight = _a.lineHeight, borderRadius = _a.borderRadius, fontColor = _a.fontColor, padding = _a.padding, restProps = __rest(_a, ["children", "error", "warning", "touched", "floatingLabel", "value", "fontSize", "fontFamily", "fontWeight", "lineHeight", "borderRadius", "fontColor", "padding"]);
    var _hasError = !!error && !!touched;
    var _hasWarning = !!warning && !!touched;
    var _b = useState(false), isFocused = _b[0], setIsFocused = _b[1];
    var handleFocus = function () { return setIsFocused(true); };
    var handleBlur = function (e) {
        var _a;
        setIsFocused(false);
        (_a = restProps.onBlur) === null || _a === void 0 ? void 0 : _a.call(restProps, e);
    };
    var showFloatingLabel = isFocused || !!value;
    return (React.createElement(InputContainer, { hasError: _hasError, hasWarning: _hasWarning },
        children,
        floatingLabel && (React.createElement(Label, { isFloating: showFloatingLabel, fontFamily: fontFamily }, floatingLabel)),
        React.createElement(InputWrapper, null,
            React.createElement(InputField, __assign({ fontSize: fontSize, fontFamily: fontFamily, fontWeight: fontWeight, lineHeight: lineHeight, borderRadius: borderRadius, fontColor: fontColor, padding: padding, hasError: _hasError, hasWarning: _hasWarning, value: value, onFocus: handleFocus, onBlur: handleBlur }, restProps)))));
};
export default Input;
